import React, { PureComponent } from "react";
import { ramdomizeNumber } from "../assets/js/404";
import "../assets/css/404.css";

class PageNotFound extends PureComponent {

    constructor(props) {
        super(props);
    }
    componentDidMount() {
        ramdomizeNumber();
    }
    render() {
        return (
            <div class="container" >
                <div class="error">
                    <div class="container-floud" >
                        <div class="col-xs-12 ground-color text-center">
                            <div class="container-error-404" >
                                <div class="clip"><div class="shadow"><span class="digit thirdDigit"></span></div></div>
                                <div class="clip"><div class="shadow"><span class="digit secondDigit"></span></div></div>
                                <div class="clip"><div class="shadow"><span class="digit firstDigit"></span></div></div>
                            </div>
                            <h2 class="h1">Désolé! La page que vous recherchez est introuvable.</h2>
                            <div class="error-details">
                                Le lien que vous avez suivi peut être incorrecte ou  la page avoir peut avoir été supprimée. <br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default PageNotFound;